import React from 'react';
import profanity from 'leo-profanity';

import {isAdminPage, roundedElements} from 'Services/BaseHelpers';

import EmojiPicker from './EmojiPicker';
import Label from './Label';

/**
 * @function Textarea
 * @param {string} containerClassName
 * @param {string} className
 * @param {string} label
 * @param {string} placeholder
 * @param {string} id
 * @param {function} onChange
 * @param {string} value
 * @param {boolean} block
 * @param {string} instructions
 * @param {null|array} error
 * @param {boolean} emojiPicker
 * @param {integer} rows
 * @param {boolean} profanityCheck
 * @param labelColour
 * @return {JSX.Element}
 * @constructor
 */
const Textarea = ({
    containerClassName,
    className,
    label,
    placeholder,
    id,
    onChange,
    value,
    block = true,
    instructions,
    error = null,
    emojiPicker = false,
    rows = 2,
    profanityCheck = true,
    labelColour = 'text-white',
}) => {
    let classes = `
        ${isAdminPage() ?
            'focus:ring-light-blue-500 focus:border-light-blue-500' :
            'focus:ring-app-primary-focus focus:border-app-primary-focus'}
        mt-1 ${block ? 'block w-full': 'min-w-full'}
        border shadow-sm py-2 px-3 focus:outline-none sm:text-sm text-app-blue
        ${error ? 'border-red-800' : 'border-gray-300'}
        ${roundedElements() ? 'rounded-xl' : ''}
        ${className}

    `;

    if (!isAdminPage()) {
        // overwrite classes as required for non-admin pages.
    }

    return (
        <div className={containerClassName}>
            {label && (
                <Label
                    label={label}
                    htmlFor={id}
                    instructions={instructions}
                    error={error}
                    textColor={ error ? 'text-red-800' :  isAdminPage() ? 'text-black' : labelColour }

                />
            )}

            <textarea
                id={id}
                value={value ?? ''}
                onChange={(e) =>
                    onChange(profanityCheck ? profanity.clean(e.target.value, '') : e.target.value)
                }
                placeholder={placeholder}
                className={classes}
                rows={rows}
            />

            {emojiPicker &&
                <EmojiPicker
                    buttonClassName="absolute top-4 right-6"
                    onChange={(v) => onChange(value + v)}
                />
            }
        </div>
    )
};

export default Textarea;
